import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#sobre", label: "Sobre" },
  { href: "#areas", label: "Áreas" },
  { href: "#metodo-slim-pro", label: "Slim Pro" },
  { href: "#depoimentos", label: "Depoimentos" },
  { href: "#atendimento", label: "Atendimento" },
  { href: "#faq", label: "FAQ" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-500 ${
        scrolled
          ? "bg-[#FDFBF7]/90 backdrop-blur-md shadow-[0_4px_20px_rgba(62,39,35,0.06)]"
          : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 md:px-12">
        <a
          href="#inicio"
          className="font-serif text-xl tracking-tight text-[#3E2723] md:text-2xl"
          data-testid="navbar-logo"
        >
          Dra. <em className="italic text-[#8B6F1F]">Mariana Alves</em>
        </a>

        <ul className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="text-sm text-[#4E342E] transition-colors hover:text-[#D4AF37]"
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href="#contato"
          className="hidden rounded-full border border-[#3E2723] px-5 py-2 text-xs uppercase tracking-[0.2em] text-[#3E2723] transition-all hover:bg-[#3E2723] hover:text-white lg:inline-block"
          data-testid="navbar-cta"
        >
          Agendar
        </a>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden"
          aria-label="Abrir menu"
          data-testid="navbar-mobile-toggle"
        >
          {open ? (
            <X className="h-6 w-6 text-[#3E2723]" />
          ) : (
            <Menu className="h-6 w-6 text-[#3E2723]" />
          )}
        </button>
      </nav>

      {open && (
        <div
          className="border-t border-[#EFEBE1] bg-[#FDFBF7] lg:hidden"
          data-testid="navbar-mobile-menu"
        >
          <ul className="flex flex-col px-6 py-4">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block py-3 text-sm text-[#3E2723]"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contato"
                onClick={() => setOpen(false)}
                className="mt-2 block rounded-full bg-[#D4AF37] py-3 text-center text-xs uppercase tracking-[0.2em] text-white"
              >
                Agendar
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
